<!-- Copyright © 2024 Insurance Services Office, Inc. All rights reserved -->

<app-header></app-header>
<app-loading></app-loading>
<div class="d-flex" style="padding-top: 36px; flex: 1">
  <div class="sidebar-nav" [class.visible]="isSidebarVisible" [class.hidden]="!isSidebarVisible">
    <app-left-menu></app-left-menu>
  </div>
  <div class="main-content-wrapper">
    <router-outlet></router-outlet>
    <app-toasts></app-toasts>
  </div>
</div>
<app-footer></app-footer>

@if (isUiBlocked) {
  <div class="fullscreen-block-overlay">
  <div class="fullscreen-block-spinner">
    <span>Downloading files, please wait...</span>
  </div>
</div>
}
